'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  expanded: _propTypes2.default.bool
};
var defaultProps = {
  expanded: false
};

var expanded = function expanded(_ref) {
  var themeFromProvider = _ref.theme,
      expanded = _ref.expanded;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var styleKey = expanded ? 'expanded' : 'collapsed';
  var _theme$reactackle$com = theme.reactackle.components.accordion.item.title[styleKey],
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      fontWeight = _theme$reactackle$com.fontWeight,
      color = _theme$reactackle$com.color,
      textTransform = _theme$reactackle$com.textTransform,
      paddingTop = _theme$reactackle$com.paddingTop,
      paddingBottom = _theme$reactackle$com.paddingBottom,
      paddingLeft = _theme$reactackle$com.paddingLeft,
      paddingRight = _theme$reactackle$com.paddingRight;
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';text-transform:', ';padding-top:', ';padding-bottom:', ';padding-left:', ';padding-right:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, fontWeight, textTransform, (0, _reactackleCore.getValueString)(paddingTop), (0, _reactackleCore.getValueString)(paddingBottom), (0, _reactackleCore.getValueString)(paddingLeft), (0, _reactackleCore.getValueString)(paddingRight));
};

var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TitleStyled'
})(['flex-grow:1;position:relative;z-index:1;user-select:none;', ''], expanded);

TitleStyled.propTypes = propTypes;
TitleStyled.defaultProps = defaultProps;